//#region libraries   
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
//custom component
import { NavBarNew, Footer } from '_molecules';
//bootstrap
import { Container, Col, Row, Image } from 'react-bootstrap';

import './styles.css';
import { useMediaQuery } from 'react-responsive'
import { Colors } from '_styles';

// images
import consultants from "_assets/images/business/consultants.png";
import mobile from "_assets/images/business/mobile-app.png";
import calendar from "_assets/images/business/calendar.png";

import { BsChevronRight } from "react-icons/bs";
//#endregion

function Business() {

    const isPhone = useMediaQuery({ query: '(max-width: 1224px)' })

    const [hover, setHover] = useState(false);
    const history = useHistory();

    const Tile = (props) => {

        const [toggle, setToggle] = useState(false);

        return (
            <Container onMouseOver={() => { setToggle(false) }} onMouseLeave={() => { setToggle(false) }} style={{ boxShadow: toggle ? "2px 2px 8px 2px #307FE2" : "0px 4px 8px 0px #9E9E9E", width: 320, height: 350, padding: 5, borderRadius: 20 }}>

                <Container>
                    <p style={{ fontSize: 20, fontWeight: '200', color: !toggle ? '#307FE2' : '#0653B4', textAlign: 'center' }}>{props.title}</p>
                </Container>

                <Container className="d-flex justify-content-center">

                    <Image
                        src={props.image}
                        style={{ width: 'auto', height: '100px' }}
                    />
                </Container>

                <Container className="mt-3">
                    <p style={{ fontSize: 18, fontWeight: '200' }}>{props.subtitle}</p>
                    <p style={{ fontSize: 18, fontWeight: '200', opacity: !props.toggle ? 0.6 : 1.0 }}>{props.subsubtitle}</p>
                </Container>
            </Container>
        );
    }

    if (!isPhone) {
        return (
            <div style={{padding:0, margin:0}}>

                <NavBarNew from={'business'}/>

                <Container fluid={true} className="mt-5">

                    {/* Info Row */}
                    <Container>
                        <Row>
                            <Col className="mt-5">
                                <h1 className="fw-bold fs-1">Products and Services</h1>
                                <p className="fw-lighter fs-4 mt-5">At PRM Assist we are motivated to provide products and services to solve issues in the aviation and accessibility industry.</p>
                                <p className="fw-lighter fs-4">Currently, we provide solutions for passengers, airport and airline staff.</p>
                            </Col>
                        </Row>
                    </Container>

                    {/* Tiles */}
                    <Container className="mt-5">
                        <Row xs={2}>
                            <Tile
                                title={"PRM Assist Mobile App"}
                                subtitle={""}
                                subsubtitle={"Our mobile app makes creating bookings for assistance simple. Available for free on iOS and Android"}
                                image={mobile}
                            />
                            <Tile
                                title={"PRM Assist Portal"}
                                subtitle={""}
                                subsubtitle={"Our online portal allows airport staff to view and create assistance bookings, aswell as interacting with analytics and feedback."}
                                image={calendar}
                            />
                            <Tile
                                title={"PRM Assist Consultancy"}
                                subtitle={""}
                                subsubtitle={"Our team has global experience in airport operations. We provide consultancy on all aspects of PRM Assistance"}
                                image={consultants}
                            />
                        </Row>
                    </Container>

                    <Container className="d-flex justify-content-center mt-5" onClick={() => { history.push('/contact'); }} onMouseOver={() => { setHover(true) }} onMouseLeave={() => { setHover(false) }} style={{ cursor: 'pointer' }}>
                        <p className="fs-4" style={{ textAlign: 'center', color: Colors.PRM_LIGHT_BLUE }}>Contact us</p>
                        <BsChevronRight size={22} style={{ marginTop: 8, marginLeft: 12 }} color='#307FE2' />
                    </Container>

                </Container>

                <Footer />
            </div>
        );
    }
    else {
        return (
            <>
                <NavBarNew />

                <Footer />
            </>
        )
    }
};

export default Business;